/* eslint-disable */
import React, { useContext } from 'react';
import { selectWallet, signOut } from "../../services/login";
import { AuthContext } from '../../auth/AuthContext';
import logo from '../../assets/Logo-NEXT-Business-positivo.svg';
import Load from '../load';

import {
    Card,
    CardHeader,
    CardBody
} from '@progress/kendo-react-layout';

import { Button } from '@progress/kendo-react-buttons';


import './styles.css';

export default function Wallet() {
    const { user, setWalletSelected, setUser } = useContext(AuthContext);

    const onSelectWallet = (wallet) => {
        selectWallet(wallet, setWalletSelected);
    };

    if (!user?.ListaDeCarteiras || user.ListaDeCarteiras.length === 0) {
        return <Load />;
    }

    return (
        <div className="auth-bg">
            <Card className="auth-card">
                <CardHeader className="auth-header">
                    <img src={logo} alt="Logo" className="auth-logo" />
                </CardHeader>

                <CardBody>
                    <div className="wallet-buttons">
                        {user?.ListaDeCarteiras?.map((c, idx) => (
                            <Button
                                key={idx}
                                className="wallet-btn"
                                fillMode="solid"
                                onClick={() => onSelectWallet(c)}
                            >
                                {c.NomeCarteira}
                            </Button>
                        ))}
                        <div style={{ marginTop: 18 }}>
                            <Button
                                className="wallet-logout"
                                fillMode="outline"
                                onClick={() => signOut(setUser, setWalletSelected)}
                            >
                                Sair
                            </Button>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}
